import {
  Entity,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  ManyToOne,
  JoinColumn,
  PrimaryGeneratedColumn,
} from 'typeorm';

import { Industry, VatType } from '../../utils/enums.utils';
import { CompanyStatus } from '../../interface/companies/company-response.interface';
import { UsersEntity } from '../users/user.entity';
import { AttachmentsEntity } from '../attachments/attachments.entity';

@Entity('companies')
export class CompanyEntity {

  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column()
  company_name!: string;

  @Column({ type: 'varchar', nullable: true })
  industry!: Industry;

  @Column({ type: 'varchar' })
  vat_type!: VatType;

  @Column({ nullable: true, type: 'text' })
  product_service?: string;

  @Column({ nullable: true })
  payment_terms?: string;

  @Column({ type: 'varchar' })
  status!: CompanyStatus;

  @Column({ nullable: true, type: 'text' })
  address?: string;

  @Column({ nullable: true })
  tin_number?: string;

  @Column({ length: 100 })
  customer_code!: string;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;

  // RELATIONS

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'created_by_id' })
  created_by?: UsersEntity;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by_id' })
  updated_by?: UsersEntity;

  @ManyToOne(() => AttachmentsEntity, { nullable: true })
  @JoinColumn({ name: 'attachment_company_logo_id' })
  attachment_company_logo?: AttachmentsEntity;

  @ManyToOne(() => AttachmentsEntity, { nullable: true })
  @JoinColumn({ name: 'attachment_org_chart_id' })
  attachment_org_chart?: AttachmentsEntity;
}